import { CalendarView } from "./view/CalendarView";
import { CalendarData } from "./model/CalendarData";
import { NavigationView } from "./view/NavigationView";
import { BookingData } from "./model/BookingData";
import { Cell } from "./view/Cell";
import { BookingHandler } from "./model/BookingHandler";
import { FormView } from "./view/FormView";

export class BookingCtrl
{
	constructor(
		private readonly _calendarData: CalendarData,
		private readonly _bookingData: BookingData,
		private readonly _bookingHandler: BookingHandler,
		private readonly _navView: NavigationView,
		private readonly _calendarL: CalendarView,
		private readonly _calendarR: CalendarView,
		private readonly _formView: FormView
	)
	{
		this._navView.initNavPrev(() => this.onPrevMonth());
		this._navView.initNavNext(() => this.onNextMonth());

		this._calendarL.setCellListener((cell: Cell) => this.onCellClick(cell));
		this._calendarR.setCellListener((cell: Cell) => this.onCellClick(cell));

		this.reset();
	}

	private onNextMonth(): void
	{
		this._calendarData.onNextMonth();
		this.reset();
	}

	private onPrevMonth(): void
	{
		this._calendarData.onPrevMonth();
		this.reset();
	}

	private reset(): void
	{
		const isPrevNavEnabled = this._calendarData.isPrevNavEnabled();
		this._navView.reset(isPrevNavEnabled);
		this._calendarL.render(this._calendarData.yearL, this._calendarData.monthL);
		this._calendarR.render(this._calendarData.yearR, this._calendarData.monthR);

		this._calendarL.setAvailability(this._bookingData);
		this._calendarR.setAvailability(this._bookingData);

		this._bookingHandler.reset();
		this._formView.reset();
	}

	private onCellClick(cell: Cell): void
	{
		this._bookingHandler.onCellClick(cell);
		const from = this._bookingHandler.from;
		const to = this._bookingHandler.to;

		this._calendarL.reserve(from, to);
		this._calendarR.reserve(from, to);

		this._formView.update(from, to);
	}
}
